/* eslint-disable */
import _ from "lodash";

class Particle {
  constructor(scene) {
    this.scene = scene;

    this.fountain = BABYLON.MeshBuilder.CreateBox("box", 1, this.scene);
    this.fountain.scaling.x = 500;
    this.fountain.scaling.y = 500;
    this.fountain.scaling.z = 500;
    this.fountain.visibility = 0;

    this.speed = -50;
    this.season = this.getSeason(new Date());

    this.particleList = {};
    this.particleList.spring = this.initParticle("/images/particle1.png");
    this.particleList.summer = this.initParticle("/images/particle2.png");
    this.particleList.autumn = this.initParticle("/images/particle3.png");
    this.particleList.winter = this.initParticle("/images/particle4.png");
  }

  //------------------------------------
  // Initialize
  //------------------------------------
  initParticle(texture) {
    let particleSystem = new BABYLON.ParticleSystem(
      "particles",
      10000,
      this.scene
    );
    particleSystem.activeParticleCount = 50000;

    particleSystem.emitRate = 0;
    particleSystem.particleTexture = new BABYLON.Texture(texture, this.scene);

    particleSystem.emitter = this.fountain;

    particleSystem.addVelocityGradient(
      0,
      this.speed / this.fountain.scaling.y / 2,
      this.speed / this.fountain.scaling.y
    );

    particleSystem.minLifeTime = 2;
    particleSystem.maxLifeTime = 4;

    particleSystem.minSize = this.fountain.scaling.y / 1000;
    particleSystem.maxSize = this.fountain.scaling.y / 100;

    particleSystem.minAngularSpeed = 0;
    particleSystem.maxAngularSpeed = Math.PI;

    particleSystem.minInitialRotation = 0;
    particleSystem.maxInitialRotation = Math.PI;

    particleSystem.blendMode = BABYLON.ParticleSystem.BLENDMODE_ADD;

    particleSystem.start();

    return particleSystem;
  }

  //------------------------------------
  // Start / Stop
  //------------------------------------
  startParticle(season) {
    this.particleList[season].emitRate = 500;
    this.season = season;
  }

  stopParticle(season) {
    this.particleList[season].emitRate = 0;
  }

  start() {
    this.particleList[this.season].emitRate = 500;
  }

  stop() {
    this.particleList.spring.emitRate = 0;
    this.particleList.summer.emitRate = 0;
    this.particleList.autumn.emitRate = 0;
    this.particleList.winter.emitRate = 0;
  }

  //------------------------------------
  // Update
  //------------------------------------
  changeDate(date) {
    let seasonCurrent = this.season;
    let seasonNew = this.getSeason(date);

    if (seasonNew !== seasonCurrent) {
      if (seasonCurrent) this.stopParticle(seasonCurrent);
      this.startParticle(seasonNew);
    }
  }

  getSeason(date) {
    let seasonNew;
    let month = date.getMonth() + 1;

    if (month === 12 || month <= 2) {
      seasonNew = "winter";
    } else if (month >= 3 && month <= 5) {
      seasonNew = "spring";
    } else if (month >= 6 && month <= 8) {
      seasonNew = "summer";
    } else if (month >= 9 && month <= 11) {
      seasonNew = "autumn";
    }

    return seasonNew;
  }

  updateScale(scale) {
    this.fountain.scaling = scale;

    _.each(this.particleList, particleSystem => {
      particleSystem.addVelocityGradient(
        0,
        this.speed / this.fountain.scaling.y / 2,
        this.speed / this.fountain.scaling.y
      );

      particleSystem.minSize = this.fountain.scaling.y / 1000;
      particleSystem.maxSize = this.fountain.scaling.y / 100;
    });
  }

  updatePosition(position) {
    this.fountain.position = position;
  }
}
export default Particle;
